import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: "utc",
    standalone: true
})
export class UtcPipe implements PipeTransform {
  transform(time: string) {
    let utc = time + 'Z'
    let timestamp = new Date(utc.toLocaleString())
    return timestamp
  }
}

@Pipe({
    name: "browser",
    standalone: true
})
export class BrowserPipe implements PipeTransform {
  transform(browser: string | undefined) {
    if (!browser) return '';
    return browser.replace(/\s+/g, '');
  }
}

@Pipe({
    name: 'capitalizeWords',
    standalone: true
})
export class CapitalizeWordsPipe implements PipeTransform {
  transform(value: string |undefined): string {
    if(!value) return '';
    else return value
      .replace(/-/g, ' ') 
      .split(' ') 
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) 
      .join(' ') ;
  }
}

@Pipe({
    name: 'flagicon',
    standalone: true
})
export class FlagIconPipe implements PipeTransform {
  transform(isoCode: string | undefined) {
    if (!isoCode) return '';
    return "fi fi-"+ isoCode.toLowerCase();
  }
}